import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'

const getNames = (subjects = {}, excludeUid = null) =>
  Object.values(subjects || {})
    .filter(v => excludeUid !== v.uid)
    .reduce(
      (acc, cur) =>
        acc.concat(
          decode(cur?.text?.toString() || '')
            .trim()
            .toLowerCase()
        ),
      []
    )

const getTitleError = (value = '', names = []) => {
  if ('' === value.trim()) {
    return { type: 'title', message: ['Title cannot be empty!'] }
  }
  if (names.includes(value.trim().toLowerCase())) {
    return { type: 'title', message: ['Choose a unique name!'] }
  }
  return { type: 'title' }
}

const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']

const getImageError = file => {
  if (file.size > 10 * 1024 * 1024) {
    return { type: 'image', message: ['Maximum image size is 10mb'] }
  }
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return { type: 'image', message: ['Unsupported image format'] }
  }
  return { type: 'image' }
}

export { getNames, getTitleError, getImageError }
